import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { ReportAnIssueResponse } from "@components/molecules/ReportAnIssue/types";

export const useReportAnIssue = () => {
  return useMutation({
    mutationFn: (data: {
      issue_description: string;
      issue_type_ids: any;
      item_detail: any;
      stock_item_id: number;
    }) => apiClient.post(Routes.REPORT_AN_ISSUE, data),
  });
};

export const useIssueTypes = () => {
  return useQuery({
    queryKey: ["ISSUE_TYPES"],
    queryFn: () => apiClient.get<ReportAnIssueResponse>(Routes.ISSUE_TYPES),
  });
};
